module.exports = __webpack_public_path__ + "img/el-ic-contacts.f9bb46f1.svg";